export default "__VITE_ASSET__tbV5o7rgOmJgt7fUpi93jQ__"